import React, { useEffect } from 'react';
import leftControl from '../../assets/icons/new_icon/LeftControl.svg';
import RControl from '../../assets/icons/new_icon/RControl.svg';
interface Props {
  totalItems: any;
  totalPages: any;
  currentPage: any;
  pageSize: any;
  setCurrentPage: any;
  savedPackageUnit?: string;
}

function NewPaginationContainer({
  totalItems,
  totalPages,
  currentPage,
  pageSize,
  setCurrentPage,
  savedPackageUnit,
}: Props) {
  useEffect(() => {
    setCurrentPage(currentPage);
  }, [currentPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 3; // Define the maximum number of visible pages

    // Logic to determine which pages to display
    let startPage = currentPage;
    let endPage = currentPage + maxVisiblePages - 1;
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Render page numbers
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          className={`page-item ${currentPage === i ? 'active' : ''}`}
          key={i}
        >
          <button
            className='page-link'
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Add ellipsis before next button if necessary
    if (endPage < totalPages) {
      pageNumbers.push(
        <li
          className='page-item disabled'
          key='ellipsis'
        >
          <span className='page-link'>...</span>
        </li>
      );
    }

    return pageNumbers;
  };

  return (
    <nav aria-label='Page navigation example'>
      <ul className='pagination justify-content-end gap-2 mb-0 pb-0'>
        <li
          className={`page-item leftcontrol ${
            currentPage === 1 ? 'disabled' : ''
          }`}
        >
          <button
            className=' leftcontrol'
            onClick={() => {
              currentPage !== 1 && handlePageChange(currentPage - 1);
            }}
          >
            <img src={leftControl} />
          </button>
        </li>
        {renderPageNumbers()}
        <li
          className={`page-item ${
            currentPage === totalPages ? 'disabled' : ''
          }`}
        >
          <button
            className=' leftcontrol'
            onClick={() =>
              currentPage !== totalPages && handlePageChange(currentPage + 1)
            }
          >
            <img src={RControl} />
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default NewPaginationContainer;
